import { rulesetQuery, rulesetVersionsQuery } from "@common/api/quoting/ruleset"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/playbooks/$playbookId",
)({
  loader: async ({ context: { queryClient }, params: { playbookId } }) => {
    const [playbook] = await Promise.all([
      queryClient.ensureQueryData(rulesetQuery({ ruleset_id: playbookId })),
      queryClient.ensureQueryData(
        rulesetVersionsQuery({ ruleset_id: playbookId }),
      ),
    ])
    return { breadcrumb: playbook.name }
  },
})
